import React, { useEffect, useCallback } from 'react';
import { useLanguage } from '../../hooks/useLanguage';

export const Lightbox = ({ artwork, onClose, onNext, onPrev }) => {
  const { t } = useLanguage();

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') onClose();
    if (e.key === 'ArrowRight') onNext();
    if (e.key === 'ArrowLeft') onPrev();
  }, [onClose, onNext, onPrev]);

  useEffect(() => {
    if (artwork) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [artwork, handleKeyDown]);

  if (!artwork) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/95 backdrop-blur-sm animate-fade-in"
      onClick={(e) => e.target === e.currentTarget && onClose()}
      role="dialog"
      aria-modal="true"
      aria-hidden={!artwork}
    >
      <button
        onClick={onClose}
        className="absolute text-2xl transition-colors top-6 right-6 text-white/70 hover:text-white"
        aria-label="Close lightbox"
      >
        ✕
      </button>
      
      <div className="flex flex-col lg:flex-row max-w-6xl max-h-[90vh] p-6 gap-6">
        <div className="flex items-center justify-center flex-1">
          <img
            src={artwork.file}
            alt={artwork.title}
            className="max-w-full max-h-[70vh] lg:max-h-[80vh] object-contain rounded-lg"
          />
        </div>
        
        <aside className="lg:w-80 text-[var(--muted)] space-y-4">
          <h4 className="text-[var(--text)] text-2xl font-syne font-bold">
            {artwork.title}
          </h4>
          <p className="text-lg">{artwork.artist}</p>
          <div className="pt-4 border-t border-[var(--border)] space-y-2 text-sm">
            <p>E-Mail: gaiamundi.illustration@gmail.com</p>
            <p>WhatsApp: +591 633 787 33</p>
          </div>
        </aside>
      </div>
    </div>
  );
};